module.exports = __webpack_public_path__ + "media/images/emblems/Rue-coat_of_arms-ceaf375636818d793720ac7adb61b298.svg";